import { Container } from 'react-bootstrap';
import { withLayout } from 'hocs';
import GiftsTable from 'pages/TableAdmin/MyGiftTable';
import TableHeroMock from 'components/gifts-table/TableHero/TableHeroMock';
import styles from './styles.module.scss';

function AddGiftsByExternalLink() {
  return (
    <div className={styles.container}>
      <TableHeroMock />
      <Container className="mt-4 mt-md-5">
        <GiftsTable externalLink />
      </Container>
    </div>
  );
}

export default withLayout(AddGiftsByExternalLink);
